import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Urls } from '../utilities/urls.component';

@Injectable()
export class UnderConstructionService {

  constructor(private http: HttpClient, private headers: HttpHeadersService) { }

  // get all details for under construction page
  public getUnderConstructionStatus() {
    var url: string = Urls.API_ENDPOINT + Urls.underConstruction.getUnderConstruction;
    return this.http.get<any>(url, this.headers.getCommonHttpHeaders());
  }

}
